import ReactGA from 'react-ga';

class AnalyticsService {
  constructor() {
    const isDebug = window.location.hostname === 'localhost';
    ReactGA.initialize('UA-142301335-1', {
      debug: isDebug,
      testMode: isDebug,
    });
  }

  pageView(pathname = null) {
    ReactGA.pageview(pathname ? pathname : window.location.pathname);
  }

  event({ category, action, label = null }) {
    const args = { category, action };
    if (label) {
      args.label = label;
    }
    ReactGA.event(args);
  }
}

export const analyticsService = new AnalyticsService();
